<div class="error-screen">
  <img src="../../../../assets/logo.png" alt="prepaytolls logo">
  <h4>Something went wrong</h4>
  <p>
    {{errorMessage}}
  </p>
</div>
